"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const Loading = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
    "data-testid": getTestId(_constants.LOADING),
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    minHeight: "60px",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {
      color: "primary"
    })
  });
};
exports.Loading = Loading;
